import { render, staticRenderFns } from "./s-main-panel.vue?vue&type=template&id=f408ffb6"
import script from "./s-main-panel.vue?vue&type=script&lang=js"
export * from "./s-main-panel.vue?vue&type=script&lang=js"
import style0 from "./s-main-panel.vue?vue&type=style&index=0&id=f408ffb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports